import React, { FC } from 'react';

import { Trans } from 'react-i18next';

import A from '@adsk/alloy-react-a';
import { Flex } from '@adsk/alloy-react-box';
import EmptyState from '@adsk/alloy-react-empty-state';

import { CONTACT_SUPPORT_LINK } from '../constants';
import i18n from '../helpers/i18n';

export type HttpErrorStateProps = {
  errorMessage: string;
};

const HttpErrorState: FC<HttpErrorStateProps> = ({ errorMessage }) => {
  return (
    <Flex justifyContent="center" width="100%">
      <EmptyState
        data-testid="HttpErrorState"
        style={{ display: 'block' }}
        illustrationType={
          EmptyState.ILLUSTRATION_TYPES.BUILDING_CONSTRUCTION_GREY
        }
        title={errorMessage}
      >
        <Trans
          i18nKey="REFRESH_THE_PAGE_OR_CONTACT_SUPPORT"
          components={{
            ContactSupportLink: (
              <A data-testid="ContactSupportLink" href={CONTACT_SUPPORT_LINK} />
            ),
          }}
          values={{
            link: `<ContactSupportLink>${i18n.t(
              'CONTACT_SUPPORT',
            )}</ContactSupportLink>`,
          }}
        />
      </EmptyState>
    </Flex>
  );
};
export default HttpErrorState;
